import { NavLink, Outlet } from 'react-router-dom';
import { GlobalSearch } from '../components/GlobalSearch';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { to: '/', label: 'Dashboard' },
  { to: '/users', label: 'Пользователи' },
  { to: '/vpn', label: 'VPN' },
  { to: '/servers', label: 'Серверы' },
  { to: '/payments', label: 'Платежи' },
  { to: '/promos', label: 'Промокоды' },
  { to: '/settings', label: 'Настройки' },
];

export function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside
        style={{
          width: 240,
          background: 'var(--surface)',
          borderRight: '1px solid var(--border)',
          padding: '1.5rem 1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <div>
          <strong>VPN Panel</strong>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>
            Stage 6
          </div>
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              style={({ isActive }) => ({
                padding: '0.5rem 0.75rem',
                borderRadius: 'var(--radius)',
                color: isActive ? 'var(--text)' : 'var(--text-muted)',
                background: isActive ? 'var(--surface-hover)' : 'transparent',
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div style={{ marginTop: 'auto', fontSize: '0.8rem' }}>
          <div>{user?.first_name ?? user?.username ?? user?.telegram_user_id}</div>
          <div style={{ color: 'var(--text-muted)' }}>{user?.role}</div>
          <button
            type="button"
            className="btn btn-ghost"
            style={{ marginTop: '0.5rem', width: '100%' }}
            onClick={() => logout()}
          >
            Выйти
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <header
          style={{
            padding: '1rem 2rem',
            borderBottom: '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <GlobalSearch />
        </header>
        <div style={{ flex: 1, padding: '1.5rem 2rem', overflow: 'auto' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
